module.exports = __webpack_public_path__ + "img/empty-cabinet.c89b4209.svg";